export default "__VITE_ASSET__Bby28wtr__"